import type { BuildPaymentContextInput, PaymentContext } from './types.js';

/**
 * Assembles the `payment_context` object both checkout flows send (single source
 * of truth for the shape). Returns `undefined` when no session id is available so
 * callers can spread it conditionally and keep the field additive/backwards-compatible.
 * `ip_address` is never set here — the billing-service captures it at the edge.
 * @param input Session id + optional username/email/phone/device context.
 * @returns The `payment_context`, or `undefined` when there is no session id.
 */
export function buildPaymentContext(
	input: BuildPaymentContextInput
): PaymentContext | undefined {
	if (!input?.sessionId) return undefined;

	const context: PaymentContext = { payment_session_id: input.sessionId };
	if (input.username) context.username = input.username;
	if (input.email || input.phone) {
		context.contact_info = {};
		if (input.email) context.contact_info.email = input.email;
		if (input.phone) context.contact_info.phone_number = input.phone;
	}
	if (input.deviceProfiling) context.device_profiling = input.deviceProfiling;
	return context;
}
